import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  LoadingController,
  NavParams
} from "ionic-angular";
import { Http } from "@angular/http";

// import { PrintProvider } from "../../providers/print/print";

import config from "../../config/config";
/**
 * Generated class for the ListaImpressaoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-lista-impressao",
  templateUrl: "lista-impressao.html"
})
export class ListaImpressaoPage {
  items: any[];
  filtro: any;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,
    // private printService: PrintProvider,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad ListaImpressaoPage");
    this.filtro = this.navParams.get("filtro");
    this.todos();
  }

  print(componentName) {
    // this.printService.print(componentName);
  }
  todos() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "evento/inscritos/" + this.filtro, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        let env = [];

        for (let g = 0; g < res.length; g++) {
          console.log(res[g]);
          if (res[g].usuario.dados.foto == null) {
            res[g].usuario.dados.foto = "public/perfildefault.jpg";
          }
          env.push(res[g]);
        }
        this.items = env;
        this.items.sort(this.compare);
        loading.dismiss();
      })
      .catch(error => {
        loading.dismiss();
      });
  }

  compare(a, b) {
    if (a.usuario.nome < b.usuario.nome) {
      return -1;
    }
    if (a.usuario.nome > b.usuario.nome) {
      return 1;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-impressao/lista-impressao.ts